import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {Observable, Subject} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../classes/user';
import { Settings } from '../settings';

@Injectable()

export class AuthenticationService {

  private contentHeadersJsonWithAuth: HttpHeaders;
  private contentHeadersJson: HttpHeaders;
  private baseUrl: string;

  // Eventos
  public onLoggedInUserChange: Subject<User> = new Subject<User>();

  constructor(
    private http: HttpClient,
    private router: Router
  ) {
    const loggedInUserLocalStorage = localStorage.getItem('APPTenfieldPlayerLoggedInUser');
    this.loggedInUser = User.parse(JSON.parse(loggedInUserLocalStorage));
    this.baseUrl = Settings.baseUrlBackend;
    this.ini();
  }

  // Valores internos de estado
  // tslint:disable-next-line:variable-name
  private _loggedInUser: User;

  // Propiedades publicas de estados
  public get loggedInUser(): User {
    return this._loggedInUser;
  }

  public set loggedInUser(value: User) {
    this._loggedInUser = value;
    // Actualizo el usuario guardado en el localstorage
    localStorage.setItem('APPTenfieldPlayerLoggedInUser', JSON.stringify(value));
    // Lanzo evento hacia afuera
    this.onLoggedInUserChange.next(value);
  }

  // Métodos generales
  public ini(): void {
    this.contentHeadersJson = new HttpHeaders({'Content-Type': 'application/json'});
    const authorization = 'OAuth ' + localStorage.getItem('APPTenfieldPlayerAccessToken');
    this.contentHeadersJsonWithAuth = new HttpHeaders({'Content-Type':  'application/json', Authorization: authorization});
  }

  // Métodos especificos del servicio
  public userIsLoggedIn(): boolean {
    return !!this.loggedInUser && !!this.loggedInUser.UserEmail && this.loggedInUser.UserEmail.trim().length > 0;
  }

  login(username: string, password: string): Observable<any> {
    const url = this.baseUrl + '/rest/core/servicios/iniciarSesion';
    const body = {
      ClientId: btoa(Settings.clientId),
      Email: username,
      Contrasenia: password
    };
    const options = { headers: this.contentHeadersJson };

    const request: Observable<any> = this.http.post(url, body, options);
    return request;
  }

  logout(isInPopup = false): void {
    const url = this.baseUrl + '/rest/core/servicios/cerrarSesion';
    const body = {};
    const options = { headers: this.contentHeadersJsonWithAuth };

    this.http.post(url, body, options);

    this.loggedInUser = null;
    localStorage.clear();

    if (isInPopup) {
      window.location.reload();
    } else {
      this.router.navigate(['']);
    }
  }
}
